module.exports = __webpack_public_path__ + "img/Wp_2031.f60e8528.png";